<div class="chart-wrapper">
  <div class="chart-header">
    <div class="chart-info">
      <div>
        <h5>Device Charts - {{ deviceData?.name || 'Unknown Device' }}</h5>
        <p class="mb-0 text-muted">Device Number: {{ deviceData?.deviceNumber || 'N/A' }}</p>
      </div>
      <div class="date-range ms-4">
        <mat-label>Date Range : </mat-label>

        <!-- Left Arrow Navigation -->
        <button type="button" class="btn btn-outline-primary btn-sm ms-2" (click)="navigatePrevious()"
          matTooltip="Previous {{ selectedRange }}" [disabled]="isLoading">
          <i class="fas fa-chevron-left"></i>
        </button>

        <!-- From Date -->
        <mat-form-field class="data-range-input">
          <input matInput [matDatepicker]="fromPicker" placeholder="From date" [(ngModel)]="selectedDateRange.start"
            (dateChange)="onDateRangeChange()" />
          <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
          <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>

        <span class="mx-2">to</span>

        <!-- To Date -->
        <mat-form-field class="data-range-input">
          <input matInput [matDatepicker]="toPicker" placeholder="To date" [(ngModel)]="selectedDateRange.end"
            (dateChange)="onDateRangeChange()" />
          <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
          <mat-datepicker #toPicker></mat-datepicker>
        </mat-form-field>

        <!-- Right Arrow Navigation -->
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="navigateNext()"
          matTooltip="Next {{ selectedRange }}" [disabled]="isLoading">
          <i class="fas fa-chevron-right"></i>
        </button>

        <button type="button" class="btn btn-primary sync-btn ms-2" (click)="onSyncRange()"
          matTooltip="Restore Default Range">
          <i class="fas fa-arrows-rotate"></i>
        </button>
        <button *ngIf="showCloseButton" type="button" class="btn btn-primary ms-2" (click)="closeChart.emit()"
          matTooltip="Close Chart">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <div class="chart-filters">
      <div class="d-flex ms-auto">
        <mat-radio-group [(ngModel)]="selectedRange" (change)="onRangeChange()" class="range-radio-group">
          <mat-radio-button value="day" class="range-radio">Day</mat-radio-button>
          <mat-radio-button value="week" class="range-radio">Week</mat-radio-button>
          <mat-radio-button value="month" class="range-radio">Month</mat-radio-button>
          <mat-radio-button value="year" class="range-radio">Year</mat-radio-button>
        </mat-radio-group>
        <button type="button" class="btn btn-primary ms-3" (click)="openDataView()"
          [disabled]="hasError || isLoading || noData">
          View Data
        </button>
      </div>
    </div>
  </div>

  <div class="charts-container">
    <div [class]="useRightLegend ? 'chart-with-legends' : ''">
      <div [class]="useRightLegend ? 'chart-item chart-area' : 'chart-item'">
        <!-- Error state -->
        <div *ngIf="hasError" class="alert alert-danger text-center py-5">
          <i class="fas fa-exclamation-triangle fa-3x mb-3"></i>
          <p class="mb-2">{{ errorMessage }}</p>
          <button type="button" class="btn btn-primary mt-2" (click)="loadChartData()">
            <i class="fas fa-refresh me-2"></i>Retry
          </button>
        </div>

        <!-- Initial loading overlay -->
        <div *ngIf="!hasError && isLoading && !chartInstance" class="initial-loading-overlay">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <!-- No data message -->
        <div *ngIf="!hasError && !isLoading && noData" class="no-data-overlay">
          <i class="fas fa-chart-line fa-2x mb-2 text-muted"></i>
          <p class="text-muted mb-0">No data available for the selected range.</p>
        </div>

        <!-- Chart container -->
        <div *ngIf="!hasError && !noData" echarts [options]="chartOption" [style.height.px]="chartHeight" class="echart"
          (chartInit)="onChartInit($event)"></div>
      </div>

      <!-- Custom HTML Legend Panel (only when > 10 legends) -->
      <div class="legend-panel" *ngIf="useRightLegend && !hasError && !noData && legendItems.length > 0" [style.max-height.px]="chartHeight">
        <div class="legend-panel-items">
          <div *ngFor="let item of legendItems" class="legend-item"
            [class.legend-item-disabled]="!item.selected"
            (click)="toggleLegendItem(item.name)"
            [title]="item.name">
            <span class="legend-icon" [class.legend-icon-bar]="item.isBar" [style.background]="item.selected ? item.color : '#ccc'"></span>
            <span class="legend-text">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-between mt-2">
    <span class="small text-muted">Last Communicated: {{ lastCommunicated || 'N/A' }}</span>

    <!-- Legend Control Buttons -->
    <div class="legend-actions">
      <label class="form-label me-2 mb-0 small">Legends:</label>
      <button type="button" class="btn btn-primary btn-sm me-1" (click)="selectAllLegends()">Select All</button>
      <button type="button" class="btn btn-primary btn-sm" (click)="clearAllLegends()">Clear All</button>
    </div>
  </div>
</div>